import numeral from 'numeral';
import { Cell } from '@table-library/react-table-library/table';
import DomainImage from '../../../../../components/DomainImage';

function createLink(path) {
    const url = new URL(window.location);
    const intent = url.searchParams.get('intent');

    if (intent) path += `&intent=${intent}`;
    return path;
}

export const COLUMNS = (t, project_id, own_domain, keyword, onSelect, selectedDomains = []) => [
    {
        label: t('commerce.detail.market_share.columns.rank'),
        key: 'rank',
        data: 'rank',
        Component: Cell,
        cellSize: 'minmax(40px, 0.5fr)',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong className="wripe">
                    <input
                        className="css-e0dnmk"
                        type="checkbox"
                        style={{ marginRight: '10px' }}
                        onChange={() => onSelect(item.domain)}
                        checked={selectedDomains?.includes(item.domain)}
                        disabled={
                            selectedDomains?.length >= 5 && !selectedDomains?.includes(item.domain)
                        }
                    />
                    #{data}
                </strong>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.domain'),
        key: 'domain',
        data: 'domain',
        sortType: 'string',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong className="wrap-text d-flex align-items-center">
                    <DomainImage domain_name={data} className="domain_img" />
                    <a
                        href={createLink(
                            `/commerce/${project_id}/domain/?domain=${encodeURIComponent(
                                data,
                            )}&own_domain=${own_domain}&keyword=${keyword}`,
                        )}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span>{data}</span> <span style={{ fontSize: '20px' }}>→</span>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.urls'),
        key: 'urls',
        data: 'urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.projectKeywords'),
        key: 'project_keywords',
        data: 'project_keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.projectSV'),
        key: 'project_sv',
        data: 'project_sv',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.kwDifficulty'),
        key: 'kw_difficulty',
        data: 'kw_difficulty',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.organicTraffic'),
        key: 'organicTraffic',
        data: 'organicTraffic',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.organicKeywords'),
        key: 'organicKeywords',
        data: 'organicKeywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.market_share.columns.adCost'),
        key: 'adCost',
        data: 'adCost',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
];

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
